<template>
    <div id="ManageMeta">

        <div class="text-center">
            <b-spinner variant="primary" class="align-middle" v-if="loading" style="position:absolute;top:50%"></b-spinner>
        </div>

        <b-container>
                    <b-form-group>
                        Title
                        <b-form-input
                                v-model.trim="$v.title.$model"
                                :state="validateState('title')"
                                aria-described-by="input-1"
                        ></b-form-input>
                        <b-form-invalid-feedback
                                id="input-1"
                        >{{this.$t('R_ITEM_NAME')}}
                        </b-form-invalid-feedback>
                        Description
                        <b-form-input
                                v-model.trim="$v.description.$model"
                                :state="validateState('description')"
                                aria-described-by="input-2"
                        ></b-form-input>
                        <b-form-invalid-feedback
                                id="input-2"
                        >{{this.$t('R_ITEM_NAME')}}
                        </b-form-invalid-feedback>
                        <b-form-checkbox
                                id="checkbox-1"
                                v-model="nofollow"
                                name="checkbox-1"
                                value="true"
                                unchecked-value="false"
                        >
                            nofollow
                        </b-form-checkbox>
                        <b-form-checkbox
                                id="checkbox-2"
                                v-model="noindex"
                                name="checkbox-2"
                                value="true"
                                unchecked-value="false"
                        >
                            noindex
                        </b-form-checkbox>


                    </b-form-group>




        </b-container>

        <b-container fluid class="footer text-center" v-show="!loading">
            <b-button class="m-1" @click.once="ok()">{{$t('SAVE')}}</b-button>
            <b-button class="m-1" @click.once="cancel()">{{$t('CANCEL')}}</b-button>
            <b-button class="m-1" @click="showHelp=true"><font-awesome-icon icon="question" size="lg" :style="{ color: 'white' }" /></b-button>
        </b-container>

        <Help
                v-on:closeHelp="showHelp=false"
                v-bind:helpName="helpName"
                v-if="showHelp"
        />

    </div>
</template>

<script>
import { BContainer, BButton, BFormGroup, BFormInput, BFormInvalidFeedback, BSpinner, BFormCheckbox } from 'bootstrap-vue';
import Help from "./Help.vue";
import { validationMixin } from "vuelidate";
import { required, minLength, maxLength } from 'vuelidate/lib/validators';
//import {Cnst} from '@/plugins/Cnst.js';

export default {
  name: 'ManageMeta',
  components: {
    Help,
    BContainer, BButton, BFormGroup, BFormInput, BFormInvalidFeedback, BSpinner, BFormCheckbox
  },
  mixins: [validationMixin],
  data: function() {
    return {
        userName: '',
        itemName: '',
        itemType: '',
        title: '',
        description: '',
        nofollow: 'false',
        noindex: 'false',
        file: null,
        result: null,
        curTripName: '',
        desc: '',
        showAudio: false,
        act: 'editTrip',
        helpName: 'HelpManageTrip',
        showHelp: false,
        loading: false
    }
  },
  metaInfo() {
    return {
        title: 'itsmap.ru'
    }
  },
  mounted() {
    this.userName = this.$rmEncHyp(this.$route.query.userName);
    this.itemName = this.$rmEncHyp(this.$route.query.itemName);
    this.itemType = this.$route.query.itemType;
    this.getMeta();
  },
  methods: {
    async getMeta() {
        //console.log(this.userName,this.itemName, this.itemType);
        try {
            this.loading = true;
            const response = await this.$http.get('/getMeta', {
                params: {
                    itemName: this.itemName,
                    itemType: "t",
                    userName: this.userName
                }
            });
            let meta = response.data;
            if(meta.title) {
                this.title = meta.title;
                this.description = meta.description;
                if(meta.nofollow) this.nofollow = true;
                if(meta.noindex) this.noindex = true;
            }
        }
        catch(error) {
            if(typeof error.response === 'undefined') this.$serveErr('ManageMeta: getMeta() '+error.message);
            else this.$showErr(error.response.data, error.response.status);
        }
        finally {
            this.loading = false;
        }
    },
    validateState(name) {
        const { $dirty, $error } = this.$v[name];
        return $dirty ? !$error : null;
    },
    async ok() {
        this.$v.$touch();
        if(this.$v.$anyError) return;
        //alert(this.nofollow+this.noindex);
        try {
            this.loading = true;
            await this.$http.post('/setMeta', {
                itemName: this.itemName,
                itemType: this.itemType,
                userName: this.userName,
                title: this.title,
                description: this.description,
                nofollow: this.nofollow,
                noindex: this.noindex
            });
            this.$showMsg(this.$t('DONE'));
            //this.$router.go(-2);
            this.$router.push({
                path: '/UserTripsList/'+this.$addEncHyp(this.$store.state.curUserName),
                query: {
                    published: false,
                    blocked: false
                }
            }).catch( () => {} )
        } catch(error) {
            if(typeof error.response === 'undefined') this.$serveErr('ManageMeta: ok() '+error.message);
            else this.$showErr(error.response.data, error.response.status);
        }
        finally {
            this.loading = false;
        }

    },
    cancel() {
        this.$router.go(-2);
    }
  },
  validations: {
      title: {
          required,
          minLength: minLength(2),
          maxLength: maxLength(65),
      },
      description: {
          required,
          minLength: minLength(2),
          maxLength: maxLength(180),
      }
  }

}

</script>

<style>
</style>